import { useClerk } from '@clerk/react-router';
import { useCallback } from 'react';

export type UseSignOutHook = {
    signOutFn: () => void;
};

export function useSignOut(): UseSignOutHook {
    const { signOut } = useClerk();

    const signOutFn = useCallback(() => {
        void signOut({ redirectUrl: '/sign-in' });
    }, [signOut]);

    return {
        signOutFn,
    };
}
